import { API } from '@/config';
import ShRecordPlayer from '@/components/Helpers/ShRecordPlayer';

export default {
  name: 'MessagePlayer',

  components: {
    ShRecordPlayer,
  },

  props: {
    file: {
      required: true,
      type: String,
      default: null,
    },
  },

  data() {
    return {
      isFileLoaded: false,
      filePath: null,
      isWaitingForFile: false,
    };
  },

  methods: {
    async listenMessage() {
      const params = {
        fileName: this.file,
      };
      this.isWaitingForFile = true;
      const filePath = (await API.get('project/ivrBasicMessage/getMessageFile', { params })).data;
      this.isWaitingForFile = false;
      this.isFileLoaded = true;
      this.filePath = filePath;
    },
  },
};
